// extracted by mini-css-extract-plugin
module.exports = {"container":"WidgetSelect_container__1rRIY","box":"WidgetSelect_box__2U0eZ"};